import { FiFileText } from 'react-icons/fi';
import { useGetBillingInvoicesQuery } from '@/store/api/apiSlice';

export default function BillingInvoicesPanel() {
  const { data, isLoading, isFetching } = useGetBillingInvoicesQuery(undefined);
  const billingConfigured = data?.billingConfigured ?? false;

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 space-y-4">
      <div>
        <h2 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
          <FiFileText className="w-4 h-4 text-indigo-600" />
          Invoices
        </h2>
        <p className="text-[11px] text-slate-500 mt-1">
          Razorpay invoices are emailed after each charge. Contact billing@cotaskr.com for copies.
        </p>
      </div>

      {!billingConfigured ? (
        <p className="text-xs text-slate-500 rounded-lg border border-slate-100 bg-slate-50 px-3 py-4">
          Billing is not configured yet. Invoices will appear here once billing is connected.
        </p>
      ) : isLoading ? (
        <p className="text-xs text-slate-500 py-6 text-center">Loading invoices…</p>
      ) : (
        <p className="text-xs text-slate-500 rounded-lg border border-slate-100 bg-slate-50 px-3 py-4">
          Invoice history is managed by Razorpay. Check your billing email or contact billing@cotaskr.com for past invoices.
        </p>
      )}

      {isFetching && !isLoading && (
        <p className="text-[10px] text-slate-400 text-center">Refreshing…</p>
      )}
    </div>
  );
}
